import { render, staticRenderFns } from "./Oauth2Init.vue?vue&type=template&id=13c61cd6&"
import script from "./Oauth2Init.vue?vue&type=script&lang=js&"
export * from "./Oauth2Init.vue?vue&type=script&lang=js&"
import style0 from "./Oauth2Init.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports